import { IncidentNoteDTO } from "./IncidentNoteDTO";

export class IncidentNoteCreateDTO extends IncidentNoteDTO {
  incidentId: string;
  createdById: string;
}
